export const mapFetchStoresResponse = (response) => {
  const stores = response["Estabelecimentos"].map((item) => {
    return {
      id: item["Id"],
      name: item["Nome"],
    }
  }) || []

  return stores
}

export const mapFetchUsersResponse = (response) => {
  const stores = response["Usuarios"].map((item) => {
    return {
      id: item["Id"],
      name: item["Email"],
    }
  }) || []

  return stores
}

export const mapFetchCategoriesResponse = (response) => {
  const categories = response.map((item) => {
    return {
      id: item["Id"],
      name: item["NomeCategoria"],
    }
  }) || []

  return categories
}

export const mapFetchProductsResponse = (response) => {
  if (!response) return []

  const products = response.map((item) => ({
    id: item["Id"],
    name: item["NomeProduto"],
  }))

  const uniqueProducts = products.filter(
    (product, index, self) =>
      index === self.findIndex((p) => p.id === product.id)
  )

  return uniqueProducts
}

export const mapFetchCuponsResponse = (response) => {
  const stores = response["Cupons"].map((item) => {
    return {
      id: item["Id"],
      cod: item["Codigo"],
      name: item["Nome"],
      establishment: item["Estabelecimentos"],
      app: item["Aplicativo"],
      status: item["StatusCupom"]
    }
  }) || []

  return stores
}

export const mapFetchCupomUseResponse = (response) => {
  return {
    quantitiesRequests: response["QuantidadePedidos"],
    quantitiesUsers: response["QuantidadeUsos"]
  }
}

export const mapFetchCupomIdResponse = (response) => {
  const hours = response["RestricaoHorarios"].map((item) => {
    return {
      dayWeek: item["DiaDaSemana"],
      openHour: item["HoraAbertura"],
      closeHour: item["HoraFechamento"]
    }
  }) || []
  const users = response["RestricaoUsuarios"].map((item) => {
    return {
      name: item["Email"],
      id: item["Id"]
    }
  }) || []
  const establishments = response["RestricaoEstabelecimentos"].map((item) => {
    return {
      name: item["Nome"],
      id: item["Id"]
    }
  }) || []


  const produtosProibidos = response["ProdutosProibidos"]

  const restrictionProducts = produtosProibidos.map((acc) => {
    return {
      name: acc["NomeProduto"],
      id: Math.random(10000)
    }
  })

  const restrictionProductsStatus =
    (produtosProibidos && produtosProibidos.length > 0) ? produtosProibidos[0]["Participante"] : undefined;

  const categoriasProibidas = response["CategoriasProibidas"]

  const restrictionCategories = categoriasProibidas.map((acc) => {
    return {
      name: acc["NomeCategoria"],
      id: Math.random(10000)
    }
  })
  const restrictionCategoriesStatus =
    (categoriasProibidas && categoriasProibidas.length > 0) ? categoriasProibidas[0]["Participante"] : undefined;


  // const takeAlong = response["ValoresModalidadeQueroLevar"].map((item) => {
  //   return {
  //     onlyRestriction: item["ApenasRestricao"],
  //     cupomType: item["TipoValorCupom"],
  //     value: item["Valor"],
  //     valueMin: item["ValorMinimoTaxa"],
  //     valueMax: item["ValorMinimoTaxa"]
  //   }
  // }) || []
  return {
    app: response["Aplicativo"],
    name: response["Nome"],
    description: response["Descricao"],
    qtdTotal: response["Total"],
    totalUser: response["TotalPorUsuario"],
    dateExpiration: response["DataExpiracao"],
    firstUse: response["PrimeiroUso"],
    visible: response["UsoGeral"],
    visibleList: response["VisualizarListaLojas"],
    typeCupom: response["TipoValorCupom"],
    value: response["Valor"],
    valueMin: response["ValorMinimoTransacao"],
    valueMax: response["ValorMaximoTransacao"],
    restrictionHours: hours,
    products: response["ProdutosProibidos"],
    categories: response["CategoriasProibidas"],
    restrictionUsers: users,
    restrictionEstablishments: establishments,
    flagUser: response["ParticipanteRestricaoUsuarios"],
    restrictionProducts: restrictionProducts,
    restrictionCategories: restrictionCategories,
    restrictionCategoriesStatus,
    restrictionProductsStatus,

    //takeAlong: takeAlong
  }
}
